/**
 * @generated SignedSource<<8b8aae07005a1dbad5c973f44e0b95e0>>
 * @relayHash 92293e1766c5122483a78edf835d6a77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bfe34ce56275b4e9800ec66a5256bb340d00801379d1461225b805ab8c7660fb

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useCustomUITunnelsListRelay_forge_ui_Query$variables = {
  appId: string;
  environmentId: string;
  skip: boolean;
};
export type useCustomUITunnelsListRelay_forge_ui_Query$data = {
  readonly appActiveTunnels?: {
    readonly customUI: ReadonlyArray<{
      readonly resourceKey: string | null | undefined;
      readonly tunnelUrl: AGG$URL | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useCustomUITunnelsListRelay_forge_ui_Query = {
  response: useCustomUITunnelsListRelay_forge_ui_Query$data;
  variables: useCustomUITunnelsListRelay_forge_ui_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "environmentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "appId",
            "variableName": "appId"
          },
          {
            "kind": "Variable",
            "name": "environmentId",
            "variableName": "environmentId"
          }
        ],
        "concreteType": "AppTunnelDefinitions",
        "kind": "LinkedField",
        "name": "appActiveTunnels",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomUITunnelDefinition",
            "kind": "LinkedField",
            "name": "customUI",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "resourceKey"
              },
              {
                "kind": "ScalarField",
                "name": "tunnelUrl"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCustomUITunnelsListRelay_forge_ui_Query",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCustomUITunnelsListRelay_forge_ui_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "bfe34ce56275b4e9800ec66a5256bb340d00801379d1461225b805ab8c7660fb",
    "metadata": {},
    "name": "useCustomUITunnelsListRelay_forge_ui_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e8726a8dc9cd9e5e2d349cdb772813d1";

export default node;
